import React from 'react';
import Lottie from 'lottie-react';
import dogAnimation from '../assets/animation/Happy Dog.json';

const Preloader = ({ loading }) => {
  return (
    <div className={`fixed inset-0 z-[100] flex items-center justify-center bg-white transition-all duration-700 ${!loading ? 'animate-fade-out opacity-0 pointer-events-none' : ''}`}>
      <div className="relative flex flex-col items-center max-w-sm w-full px-10">
        {/* Animated Background Glow */}
        <div className="absolute -inset-20 bg-gradient-to-tr from-syana-blue-100/50 to-syana-purple-100/50 rounded-full blur-3xl animate-pulse"></div>
        
        {/* Lottie Animation Container */}
        <div className="relative w-64 h-64 flex items-center justify-center">
          <Lottie 
            animationData={dogAnimation} 
            loop={true}
            className="w-full h-full"
          />
        </div>

        {/* Branding Text */}
        <div className="  text-center space-y-3">
          <h2 className="text-3xl font-extrabold tracking-tighter text-slate-900 animate-pulse">
            Siyane <span className="text-syana-blue-600">Optometrists</span>
          </h2>
          <div className="flex items-center justify-center space-x-1">
            <div className="w-1.5 h-1.5 bg-syana-blue-600 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
            <div className="w-1.5 h-1.5 bg-syana-blue-600 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
            <div className="w-1.5 h-1.5 bg-syana-blue-600 rounded-full animate-bounce"></div>
          </div>
          <p className="text-xs font-bold text-slate-400 uppercase tracking-[0.3em] pt-2">
            Loading Luxury Vision
          </p>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
